// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"655":"25a8f865cdd0f860","864":"a9b4e8e0033d776e","971":"14e4bab86e1a23b3"}[chunkId] + ".js";
};